<template>
  <div>
    <CRow>
      <CCol xs="12" sm="4" md="3" lg="3" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker id="datepicker" v-model="dateRange" :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }"
                     is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue.start + ' - ' + inputValue.end"
                v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol v-if="!$hasAuthor('ROLE_ADMIN')" xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect
          :options="historyType.options"
          :data="historyType.data"
          ref="historyType"
        ></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect
          :options="fileType.options"
          :data="fileType.data"
          ref="fileType"
        ></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect :options="deviceInput.options" :data="deviceInput.data" ref="deviceInput"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseInput
          :options="titleFileInput.options"
          :data="titleFileInput.data"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right; margin-left: 5px"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)"
            >
              <i class="fa fa-refresh"></i>&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #serialId="{ item }">
            <td>
              <span class="badge badge-secondary">{{
                  item.serialId + ' - ' + (item.description != null && item.description != '' ? item.description : 'Chưa khai báo')
                }}</span>
            </td>
          </template>
          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-if="item.createDate == null"></td>
          </template>
          <template #updateDate="{ item }">
            <td v-if="item.updateDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.updateDate) }}
            </td>
            <td v-if="item.updateDate == null"></td>
          </template>
          <template #status="{ item }">
            <td>
              <span class="badge badge-warning" v-if="item.status == 0">Đang phát</span>
              <span class="badge badge-success" v-else-if="item.status == 1">Đã phát</span>
              <span class="badge badge-danger" v-else-if="item.status == 2">Phát lỗi</span>
            </td>
          </template>
          <template #action="{ item }">
            <td>
              <span class="view-file" v-if="item.type != 3 && item.type != 5"
                    @click="viewFile(item.type, item.fileTitle, item.url, item.content, item.youtubeId)">Ấn vào để xem</span>
            </td>
            <!-- <td v-else></td> -->
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
    <CModal title="Nội dung bản tin" :show.sync="isShowPopupContent" :closeOnBackdrop="false" size="lg">
      <CRow class="content-fade-in">
        <CCol md="12">
          <CForm class="form-basic">
            {{ contentDetail }}
          </CForm>
        </CCol>
      </CRow>
      <div slot="footer">
        <CButton color="secondary" class="btn-action-primary" @click="isShowPopupContent = false"><i
          class="fa fa-times"></i> Đóng
        </CButton>
      </div>
    </CModal>
    <BaseModal v-if="isShowModalViewFile" :title="'Xem bản tin: ' + viewFileTitle" :show.sync="isShowModalViewFile"
               size="xl"
               :closeOnBackdrop="false">
      <template v-slot:body-wrapper>
        <div class="modal-body content-fade-in" style="max-height: 80vh;">
          <template v-if="typeViewFile == 1">
            <img :src="viewFileUrl" :alt="viewFileUrl"
                 style="width: 100%;height: 100%;max-height: 75vh;object-fit: contain">
          </template>
          <template v-else-if="typeViewFile == 2">
            <VideoPlayer style="width: 100%;height: 100%;"
                         :manifest-url="viewFileUrl"
                         :poster-url="posterUrl"/>
          </template>
          <template v-else-if="typeViewFile == 4">
            <iframe :src="viewFileUrl" frameborder="0" style="width: 100%;min-height: 75vh"></iframe>
          </template>
          <!-- <template v-else-if="isYoutube">
            <iframe frameborder="0" style="width: 100%;min-height: 75vh" :src="viewFileUrl"
              title="YouTube video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
          </template> -->
        </div>
      </template>
      <template v-slot:footer>
        <div slot="footer">
          <button type="button" class="btn btn-secondary" @click="isShowModalViewFile = false"><i
            class="fa fa-close"></i> Đóng
          </button>&nbsp;
        </div>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {DatePicker} from "v-calendar";
import {HistoryTypeList} from '../../constant';
import VideoPlayer from "@/views/base/VideoPlayer";
import BaseModal from "@/views/base/BaseModal";

export default {
  name: "HistoryList",
  components: {
    BaseFormLoading,
    BaseTable,
    BaseInput,
    BaseSelect,
    DatePicker,
    VideoPlayer,
    BaseModal
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;

    return {
      loading: {value: false},
      typeViewFile: "",
      viewFileUrl: "",
      viewFileTitle: "",
      // isYoutube: false,
      isShowModalViewFile: false,
      isShowPopupContent: false,
      contentDetail: "",
      dateRange: {
        start: that.$helper.subtractNowDate(7).setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      historyType: {
        options: {
          filter: false,
          label: "Trạng thái",
        },
        data: {
          name: "status",
          items: HistoryTypeList,
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      titleFileInput: {
        options: {
          placeholder: "Tiêu đề bản tin",
          label: 'Tiêu đề bản tin'
        },
        data: {
          name: "titleFile",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      deviceInput: {
        options: {
          filter: true,
          label: "Thiết bị",
          selectAllText: "Tất cả thiết bị",
          'keyField': 'value',
          'valueField': 'text'
        },
        data: {
          name: "deviceId",
          model: null,
          items: [],
          source: {
            url: '/devices/find-all',
            isJsonContentType: false,
            response: function (dataResponse) {
              that.deviceInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      fileType: {
        options: {
          filter: false,
          label: "Loại bản tin",
        },
        data: {
          name: "fileType",
          items: [
            {
              key: "null",
              value: "Tất cả loại bản tin"
            },
            {
              key: "-1",
              value: "Văn bản chữ chạy"
            },
            {
              key: "0",
              value: "Văn bản"
            },
            {
              key: "1",
              value: "Hình ảnh"
            },
            {
              key: "2",
              value: "Video"
            },
            {
              key: "-2",
              value: "Youtube"
            },
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT", sorter: false, filter: false},
            {key: "createDate", label: "Thời gian tạo"},
            {key: "updateDate", label: "Thời gian cập nhật"},
            {key: "fileTitle", label: "Bản tin"},
            {key: "slideTitle", label: "Trình diễn"},
            {key: "serialId", label: "Mã thiết bị"},
            {key: "status", label: "Trạng thái"},
            {key: "action", label: "Thao tác"},
          ],
          slots: [
            "index",
            "serialId",
            "createDate",
            "updateDate",
            "status",
            "action"
          ],
          lazyLoad: false,
          sorter: true,
          columnFilter: false,
          tableFilter: false,
        },
        dataSource: {
          url: "/history/getPages",
          dataSubmit: function () {
            // return that.$helper.setupDataSubmit(that.$data);
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDate(that.dateRange.start);
            params.toDate = that.$helper.formatDate(that.dateRange.end);
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    viewFile(type, title, url, content, youtubeId) {
      // this.isYoutube = false;
      if (type === 0) {    /* Type = 0 là dạng văn bản */
        this.isShowPopupContent = true;
        this.contentDetail = content;
      } else if (type === 1 || type === 2) {/* Type = 1 là dạng hình ảnh, Type = 2 là dạng video */
        this.typeViewFile = type;
        this.viewFileUrl = url;
        this.isShowModalViewFile = true;
      } else if (type === 4) { /* Type = 4 là dạng tài liệu */
        var fileType = url.substring(url.lastIndexOf("."), url.length);
        this.typeViewFile = type;
        // this.viewFileUrl = "https://docs.google.com/gview?url=" + url + "&embedded=true";
        this.isShowModalViewFile = true;
        if (fileType === '.pdf') {
          this.viewFileUrl = url;
        } else if (fileType === '.doc' || fileType === '.docx') {
          this.viewFileUrl = "https://view.officeapps.live.com/op/view.aspx?src=" + url;
        }
      } else if (youtubeId != null && youtubeId.length > 0) {
        // this.isYoutube = true;
        this.viewFileUrl = "https://www.youtube.com/embed/" + youtubeId;
        // this.isShowModalViewFile = true;
        window.open(this.viewFileUrl);
      }
      this.viewFileTitle = title;
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date().setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    },
    'orgSelect.data.model': function () {
      this.loadDataMainTable();
      this.$refs.deviceInput.loadData();
    }
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
